.shortlistButton {
  width: 100%;
}

.labelWrapper {
  display: flex;
  gap: var(--spacingMd);
}
